import request from '../utils/request';
import { IResult } from '../global';

const videoApi = {
  batch: (ids: Array<number>, force?: boolean) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url:
          '/api/v2/gallerymedium/batch?ids=' +
          ids.join(',') +
          (force ? `&_t=${Date.now()}` : ''),
        method: 'get'
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  liveshowList: (
    gallery_id: string | number,
    page: number,
    page_size: number
  ) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerymedium/liveshow/list`,
        method: 'get',
        data: {
          gallery_id,
          page,
          page_size
        },
        headers: request.token
          ? {
              Authorization: request.token
            }
          : undefined
      })
        .then(resolve)
        .catch(reject);
    });
  },
  livesearch: (gallery_id: string | number, search: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerymedium/liveshow/code`,
        method: 'get',
        data: {
          gallery_id,
          search,
          page: 1,
          page_size: 40
        },
        headers: request.token
          ? {
              Authorization: request.token
            }
          : undefined
      })
        .then(resolve)
        .catch(reject);
    });
  },
  livecutlist: (
    videos: string[] | number[],
    gallery_id: string | number,
    page: number,
    page_size: number
  ) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerymedium/livecut/list`,
        method: 'get',
        data: {
          videos,
          gallery_id,
          page,
          page_size
        },
        headers: request.token
          ? {
              Authorization: request.token
            }
          : undefined
      })
        .then(resolve)
        .catch(reject);
    });
  },
  livecutsearch: (
    videos: string[] | number[],
    gallery_id: string | number,
    search: string
  ) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerymedium/livecut/list`,
        method: 'get',
        data: {
          videos,
          gallery_id,
          search,
          page: 1,
          page_size: 40
        },
        headers: request.token
          ? {
              Authorization: request.token
            }
          : undefined
      })
        .then(resolve)
        .catch(reject);
    });
  },
  liveshowup: (gallery_id: string | number, id: number, status: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerymedium/liveshow/status/${id}`,
        method: 'post',
        data: {
          gallery_id,
          status
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  }
};

export default videoApi;
